import React, { useState } from 'react';
import BooksModal from '../BooksModal';

const BooksSummery = ({ book, refetch }) => {
    const { _id, nameTitle, image, originalPrice, resalePrice, useTime, location, Post_date, details, sellerName, contact, condition,
        isConfirm } = book;
    const [books, setBooks] = useState(null);

    return (
        <div className="card w-96 bg-base-100 shadow-xl">
            <figure><img src={image} alt="books" /></figure>
            <div className="card-body my-2">
                <h2 className="card-title">{nameTitle}</h2>
                <div className='flex justify-between m-y-1'>
                    <p>Original Price: $ {originalPrice}</p>
                    <p>Resale Price :$ {resalePrice}</p>
                </div>
                <div >
                    <p>Use Time : {useTime} year</p>
                    <p>Condition: {condition}</p>
                    <p>Location : {location}</p>
                    <p> Post Date : {Post_date
                    }</p>
                    <p>Description : {details}</p>
                    <h3>Seller Name: {sellerName}</h3>
                    <p>Contact:{contact}</p>
                </div>
                <label
                    onClick={() => setBooks(book)} htmlFor="Booking-modal" className={`btn  text-white font-bold ${isConfirm ? "btn-disabled" : "btn-primary bg-gradient-to-r from-primary to-secondary"}`}>Book now
                </label>
            </div>
            <div>
                {
                    books &&
                    <BooksModal
                        booking={books}
                        setBooking={setBooks}
                        refetch={refetch}
                    ></BooksModal>
                }
            </div>

        </div>
    );
};

export default BooksSummery;